module.exports = __webpack_public_path__ + "static/media/ably.09552565.png";